var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"set-flex  n-wrap set-flex-y-center n-wrap"},[_c('span',{staticClass:"status-cell"},[_vm._v(" "+_vm._s(_vm.$t( 'gifts.reject' ))+" ")]),(_vm.showIcon)?_c('span',{staticClass:"rbi-down-arrow"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }